export default __webpack_public_path__ + "static/media/Resume, Eliot Austin-Forbes.41f22e34.pdf";